module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAOVBMVEUAAACampqOkZWOkZaOkJWNkJSNkZWOkZWOkZWTk52OkJWSkp6NkZWOkJSOkZaPkZSXl5eOkZWNkJTtJljwAAAAEnRSTlMACehX1vrPu38abBV5xGhdFrQjx+EUAAAAf0lEQVQY03VQSQ4DMQgLJGSbtf7/YyuEmolSxhcjC5slKKgXFi6dwoPIMHAc2g7k2KjFDOy/Pkg1H1VBtIpRh6mCSbkjP/mU0ZWLOUZWUWK0SWxgJcG8HUHcTjfTm346eyZaLgpVcDm3I23rl9KVTJ3+eVK4TV2wvalH+MN9fL4ULwYzAtTsAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic-search.png
// module id = 667
// module chunks = 1